(function () {
  function init(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
